import api from './api';

const authService = {
  // Login
  async login(email, password) {
    const response = await api.post('/auth/login/', { email, password });
    return response.data;
  },

  // Register
  async register(userData) {
    const response = await api.post('/auth/register/', userData);
    return response.data;
  },

  // Refresh Token
  async refreshToken(refreshToken) {
    const response = await api.post('/auth/token/refresh/', {
      refresh: refreshToken,
    });
    return response.data;
  },

  // Get User Profile
  async getProfile() {
    const response = await api.get('/auth/profile/');
    return response.data;
  },

  // Update Profile
  async updateProfile(userData) {
    const response = await api.patch('/auth/profile/', userData);
    return response.data;
  },

  // Change Password
  async changePassword(oldPassword, newPassword, newPassword2) {
    const response = await api.patch('/auth/password/change/', {
      old_password: oldPassword,
      new_password: newPassword,
      new_password2: newPassword2,
    });
    return response.data;
  },

  // ============================================
  // TWO-FACTOR AUTHENTICATION
  // ============================================

  // Get 2FA status
  async get2FAStatus() {
    const response = await api.get('/auth/2fa/status/');
    return response.data;
  },

  // Setup 2FA (generate secret)
  async setup2FA(method = 'TOTP') {
    const response = await api.post('/auth/2fa/setup/', { method });
    return response.data;
  },

  // Verify 2FA setup
  async verify2FASetup(code) {
    const response = await api.post('/auth/2fa/verify-setup/', { code });
    return response.data;
  },

  // Disable 2FA
  async disable2FA(password) {
    const response = await api.post('/auth/2fa/disable/', { password });
    return response.data;
  },

  // Regenerate backup codes
  async regenerateBackupCodes(password) {
    const response = await api.post('/auth/2fa/backup-codes/', { password });
    return response.data;
  },

  // Verify 2FA during login
  async verify2FALogin(email, code, tempToken) {
    const response = await api.post('/auth/2fa/verify/', {
      email,
      code,
      temp_token: tempToken,
    });
    return response.data;
  },

  // Send email code for 2FA
  async send2FAEmailCode(email, tempToken) {
    const response = await api.post('/auth/2fa/send-email/', {
      email,
      temp_token: tempToken,
    });
    return response.data;
  },

  // ============================================
  // EMAIL VERIFICATION
  // ============================================

  // Verify email with token
  async verifyEmail(token) {
    const response = await api.post('/auth/email/verify/', { token });
    return response.data;
  },

  // Resend verification email
  async resendVerificationEmail(email) {
    const response = await api.post('/auth/email/resend/', { email });
    return response.data;
  },

  // ============================================
  // FORGOT PASSWORD
  // ============================================

  // Request password reset
  async forgotPassword(email) {
    const response = await api.post('/auth/password/forgot/', { email });
    return response.data;
  },

  // Reset password with token
  async resetPassword(token, newPassword, newPassword2) {
    const response = await api.post('/auth/password/reset/', {
      token,
      new_password: newPassword,
      new_password2: newPassword2,
    });
    return response.data;
  },

  // Validate reset token
  async validateResetToken(token) {
    const response = await api.post('/auth/password/validate-token/', { token });
    return response.data;
  },
};

export default authService;
